export default __webpack_public_path__ + "static/media/youtube.c221bb44.svg";